import { apiRequest } from "./api";
import type { EmployeeProfile } from "../types/index";

export interface ListUsersResponse {
  items: EmployeeProfile[];
  nextKey: string | null;
}

export interface CreateUserPayload {
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  position: string;
  department: string;
  hireDate: string;
  baseSalary?: number;
  roleId?: string;
  storeId?: string;
  isStoreManager?: boolean;
  excludeFromPayroll?: boolean;
  excludeFromGovDeductions?: boolean;
  workSchedule?: { days: string[]; hoursPerDay: number };
  /** When set, a Membership record is created linking the new user to this business. */
  businessId?: string;
}

export interface UpdateUserPayload {
  firstName?: string;
  lastName?: string;
  email?: string;
  position?: string;
  department?: string;
  hireDate?: string;
  baseSalary?: number;
  storeId?: string | null;
  roleId?: string | null;
  isStoreManager?: boolean;
  excludeFromPayroll?: boolean;
  excludeFromGovDeductions?: boolean;
  workSchedule?: { days: string[]; hoursPerDay: number };
}

export const usersApi = {
  list: (limit = 25, lastKey?: string, search?: string) =>
    apiRequest<ListUsersResponse>("/admin/users", {
      params: { limit, ...(lastKey ? { lastKey } : {}), ...(search ? { search } : {}) },
    }),

  create: (payload: CreateUserPayload) =>
    apiRequest<EmployeeProfile>("/admin/users", { method: "POST", body: payload }),

  get: (userId: string) =>
    apiRequest<EmployeeProfile>(`/admin/users/${userId}`),

  update: (userId: string, payload: UpdateUserPayload) =>
    apiRequest<{ success: boolean }>(`/admin/users/${userId}`, {
      method: "PUT",
      body: payload,
    }),

  deactivate: (userId: string) =>
    apiRequest<{ success: boolean }>(`/admin/users/${userId}/deactivate`, {
      method: "POST",
    }),

  reactivate: (userId: string) =>
    apiRequest<{ success: boolean }>(`/admin/users/${userId}/reactivate`, {
      method: "POST",
    }),

  resendInvitation: (userId: string) =>
    apiRequest<{ success: boolean }>(`/admin/users/${userId}/resend-invitation`, {
      method: "POST",
    }),

  deleteUser: (userId: string) =>
    apiRequest<{ deleted: boolean }>(`/admin/users/${userId}`, {
      method: "DELETE",
    }),
};
